import "./testimonials.scss"

export default function Testimonials() {
    const data=[
        {
            id:1,
            name:"Janet visky",
            title:"Software Developer",
            img:"assets/woman.jpg",
            icon:"assets/youtube.png",
            desc:"Benzora is the designer and the developer of the "+
                  "classical theatre groups website and the manager of " +
                  "the best designer clubs. He has made us proud."
        },
        {
            id:2,
            name:"Hilda Kiser",
            title:"Co-Founder of Delka",
            img:"assets/woman1.jpg",
            icon:"assets/twitter.png",
            desc:"Services for the company are quite awesome "+
                 "and we are also in touch to make us improve on the"+
                 "same development of Applied Mechanisms",
            featured:true
        },
        {
            id:3,
            name:"Kennedy Tikan",
            title:"CEO of Ramania",
            img:"assets/man.jpg",
            icon:"assets/linkedin.png",
            desc:"Our system development and cycles were designed and "+
                 "and developed by BenzCom Solutions in a more faster "+
                 "and easier way."
        }
    ]
    return (
        <div className="testimonials" id="testimonials">
            <h2>Testimonials</h2>
            <div className="container">
                {data.map((d,kii)=>(
                <div className={d.featured ? "card featured" : "card"} key={kii}>
                    <div className="top">
                        <img src="assets/animatedrightarrow.jpg" className="left" alt=""/>
                        <img src={d.img} className="user" alt=""/>
                        <img src={d.icon} className="right" alt=""/>
                    </div>
                    <div className="center">
                       {d.desc}
                    </div>
                    <div className="bottom">
                        <h3>{d.name}</h3>
                        <h4>{d.title}</h4>
                    </div>
                </div>
                ))}
            </div>
        </div>
    )
}
